import { render, staticRenderFns } from "./AccountTypeEdit.vue?vue&type=template&id=1f19319d&scoped=true&"
import script from "./AccountTypeEdit.vue?vue&type=script&lang=js&"
export * from "./AccountTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f19319d",
  null
  
)

export default component.exports